import React, { useState, useEffect , useRef} from 'react';
import LeftSidebar from '../Tools/LeftSidebar';
import Topbar from '../Tools/Topbar';
import Pagination from '../Tools/Pagination';
import SubmitSpecialitiesmodal from './Modals/SubmittedCasemodal/Specialitiesmodal';
import SubmitAssetModal from './Modals/SubmittedCasemodal/AssetModal'
import OnSubmitModal from './Modals/NewCaseSubmission/SubmitModal';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';
import axiosInstance from '../../../api';

const SubmittedCaseDetails = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [submittedCases, setSubmittedCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    name: '',
    type: ''
  });
  const [modalData, setModalData] = useState({
      show: false,
      success: false,
      message: ''
    });

  // Pagination setup
  const [page, setPage] = useState(1);
  const limit = 10;
  const [total, setTotal] = useState(0);

  
  // Settings panel
  const settingsRef = useRef();
  const { settings, updateSetting, handleColorTheme } = useSettings();

  // Function to handle case submission
    const handleSubmitCase = async (caseId) => {
      try {
        const response = await axiosInstance.get(`/case-completed/${caseId}`);
  
        setModalData({
          show: true,
          success: response.data.status,
          message: response.data.status 
            ? "Your case has been completed successfully." 
            : response.data.message || "Case submission not allowed"
        });
        
      } catch (err) {
        setModalData({
          show: true,
          success: false,
          message: "Error submitting case"
        });
        console.error('Error submitting case:', err);
      }
    };

  useEffect(() => {
  const fetchSubmittedCases = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/case-submitted-listing', {
        params: {
          page,
          ...(filters.name && { name: filters.name }),
          ...(filters.type && { type: filters.type })
        }
      });

      setSubmittedCases(response.data.data);
      setTotal(response.data.meta?.total || response.data.data.length);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  fetchSubmittedCases();
}, [page, filters, refreshFlag]); // Include refreshFlag here

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
    setPage(1); // Reset to first page when filters change
  };

  if (loading) {
    return (
      <div id="main-wrapper">
        <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
          <Topbar toggleSidebar={toggleSidebar} />
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="card w-100 position-relative overflow-hidden">
                <div className="px-4 py-3">
                  <h5 className="card-title fw-semibold mb-0 lh-sm">Loading submitted cases...</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div id="main-wrapper">
        <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
          <Topbar toggleSidebar={toggleSidebar} />
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="card w-100 position-relative overflow-hidden">
                <div className="px-4 py-3">
                  <h5 className="card-title fw-semibold mb-0 lh-sm">Error loading submitted cases</h5>
                  <p className="text-danger">{error}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            {/* Settings Panel */}
                  <Settings
                    ref={settingsRef}
                    updateSetting={updateSetting}
                    handleColorTheme={handleColorTheme}
                    settings={settings}  // Add this line
                  />
            <div className="card w-100 position-relative overflow-hidden">
              <div className="px-4 py-3">
                <h5 className="card-title fw-semibold mb-0 lh-sm">Submitted Case Details</h5>
                <p className="card-subtitle mb-0 mt-1">Submitted case log</p>
              </div>

              <div className="card-body p-4">
                {/* Filter */}
                <div className="filter-search mt-4">
                  <h6 className="px-2 mb-0">Filter</h6>
                  <div className="filter-panel row">
                    <form>
                      <div className="form-group col-lg-3 p-2">
                        <input 
                          type="text" 
                          className="form-control" 
                          placeholder="Case Name" 
                          name="name"
                          value={filters.name}
                          onChange={handleFilterChange}
                        />
                      </div>
                      <div className="form-group col-lg-3 p-2">
                        <select 
                          className="form-control form-select"
                          name="type"
                          value={filters.type}
                          onChange={handleFilterChange}
                        >
                          <option value="">Select Case type</option>
                          <option value="Medical">Medical</option>
                          <option value="Diagnostic">Diagnostic</option>
                          <option value="Routine">Routine</option>
                          <option value="Emergency">Emergency</option>
                        </select>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Table */}
                <div className="py-3 px-0">
                  <div className="table-responsive rounded-2 ros-table">
                    <table className="table text-nowrap customize-table mb-0 align-middle">
                      <thead className="text-dark fs-4">
                        <tr>
                          {['ID', 'Case Name', 'Case Type', 'Specialities', 'Assets', 'Submission Date', 'Status', 'Action'].map((h, i) => (
                            <th key={i}>
                              <h6 className="fw-semibold mb-0">{h}</h6>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {submittedCases.map((caseItem, index) => (
                          <tr key={index}>
                            <td><p className="mb-0 fw-normal">{caseItem.id}</p></td>
                            <td><p className="mb-0 fw-normal">{caseItem.case_name}</p></td>
                            <td><p className="mb-0 fw-normal">{caseItem.case_type}</p></td>
                            <td>
                              <p className="mb-0 fw-normal">
                                <a 
                                  className="text-primary" 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#bs-show-speciality"
                                  data-case-id={caseItem.id}
                                >
                                  Show
                                </a>
                              </p>
                            </td>
                            <td>
                              <p className="mb-0 fw-normal">
                                <a 
                                  className="text-primary" 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#bs-show-Assets"
                                  data-case-id={caseItem.id}
                                >
                                  Show
                                </a>
                              </p>
                            </td>
                            <td><p className="mb-0 fw-normal">{caseItem.submitted_at}</p></td>
                            <td>
                              <p className="mb-0 fw-normal">
                                <span className="round-8 text-bg-success rounded-circle me-2 d-inline-block"></span>
                                Progress
                              </p>
                            </td>
                            <td>
                              <button type="button" className="btn mb-1 waves-effect waves-light btn-rounded btn-outline-success"
                              onClick={() => handleSubmitCase(caseItem.id)}
                              >
                                Complete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Update the OnSubmitModal component */}
                <OnSubmitModal 
                show={modalData.show}
                success={modalData.success}
                message={modalData.message}
                onClose={() => {
                  setModalData({ ...modalData, show: false });
                  setRefreshFlag(prev => !prev); // Triggers useEffect to refetch cases
                }}
                />    

                {/* Pagination */}
                <Pagination
                  total={total}
                  limit={limit}
                  page={page}
                  onPageChange={setPage}
                />
                 <SubmitSpecialitiesmodal/>
                 <SubmitAssetModal/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dark-transparent sidebartoggler" onClick={toggleSidebar}></div>
    </div>
  );
};

export default SubmittedCaseDetails;